import { createFileRoute } from '@tanstack/react-router'
import { requireLoggedIn } from 'sierra-client/core/require-logged-in'
import { Route as IndexRoute } from './index.route'

/** Legacy route for backwards compatibility with the old link format. To be redirected to `/s/$courseId/` by V4Redirect. */
export const Route = createFileRoute('/program/$programId/course/$courseId/$')({
  component: requireLoggedIn(() => null, { allowScorm: true }) as React.FC,
  params: IndexRoute.options.params,
})
